export const SET_MESSAGE = 'SET_MESSAGE';

export const setMessage = (text: string, isDirty?: boolean) => ({
    isDirty,
    text,
    type: SET_MESSAGE,
});

export const initialState = {};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_MESSAGE: {
            return {
                isDirty: action.isDirty,
                text: action.text,
            };
        }
        default:
            return state;
    }
};
